import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';

import { DATE_RANGES } from '@/constants/analytics';

dayjs.extend(utc);


function getDatesByRange(range, { minimalTimestampMs = 0, allTimeStartTimestampMs = 0 } = {}) {
  const todayUtc = dayjs().utc();

  let startTimestamp;
  let endTimestamp = todayUtc.endOf('hour');

  switch (range) {
    case DATE_RANGES.ALL_TIME:
      startTimestamp = dayjs(allTimeStartTimestampMs).utc().startOf('year');
      break;
    case DATE_RANGES.REALTIME:
      startTimestamp = todayUtc.startOf('date');
      break;
    case DATE_RANGES.THIS_MONTH:
      startTimestamp = todayUtc.startOf('month');
      break;
    case DATE_RANGES.THIS_YEAR:
      startTimestamp = todayUtc.startOf('year');
      break;
    case DATE_RANGES.LAST_MONTH: {
      const prevMonth = todayUtc.add(-1, 'month');

      startTimestamp = prevMonth.startOf('month');
      endTimestamp = prevMonth.endOf('month');
      break;
    }
    default:
      throw new Error('Not correct range is provided');
  }

  const endTimestampMs = +endTimestamp;
  let startTimestampMs = +startTimestamp;

  if (startTimestampMs < minimalTimestampMs) {
    startTimestampMs = minimalTimestampMs;
  }

  return [startTimestampMs, endTimestampMs];
}

export default getDatesByRange;
